<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/grupoProduto"> Cadastro/Produtos e Serviços/Grupos </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="grupoProduto.ativo"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/grupoProduto" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/grupoProduto" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { editarGrupoProdutoAsync } from "../../../services/grupoProdutoService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarGrupo",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("grupoProduto", ["grupoProduto"]),
  },
  methods: {
    ...mapActions("grupoProduto", ["updateGrupoProduto"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarGrupoProdutoAsync(
          this.grupoProduto.id,
          this.descricao,
          this.grupoProduto.ativo
        );
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Descupe, falha na operação!", "error");
        } else {
          this.updateGrupoProduto(resposta);
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/grupoProduto");
        }
      }
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(6);
    this.descricao = this.grupoProduto.descricao;
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
